import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { customTableStyles } from "../../assets/CustomTableStyles";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

const dummyData = [
  {
    code: "0000001",
    description: 'Boy Shirt 18"',
    category: "Uniform",
    uom: "PCS",
    quantity: 50,
    cost: 45,
  },
  {
    code: "0000002",
    description: 'Boy Shirt 17"',
    category: "Uniform",
    uom: "PCS",
    quantity: 28,
    cost: 42,
  },
  {
    code: "0000003",
    description: 'Boy Shirt 16"',
    category: "Uniform",
    uom: "PCS",
    quantity: 29,
    cost: 40,
  },
  {
    code: "0000004",
    description: "Chrome Book",
    category: "IT Equipment",
    uom: "PCS",
    quantity: 40,
    cost: 100,
  },
];

const uniqueCategories = [...new Set(dummyData.map((item) => item.category))];

const SalesOfferForm = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [salesOfferNo, setSalesOfferNo] = useState("");

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    trigger,
    formState: { errors },
  } = useForm();

  const [items, setItems] = useState([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [productImageFiles, setProductImageFiles] = useState([]);
  const [productPreviewUrls, setProductPreviewUrls] = useState([]);

  const sellingPrice = watch("sellingPrice") || 0;
  const vatApplied = watch("vatApplied");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [salesOfferDetails, setSalesOfferDetails] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}ItemCategory`);
        const data = await response.json();

        const uniqueCategories = Array.from(
          new Map(data.map((item) => [item.categoryID, item])).values()
        );

        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };

    fetchCategories();
  }, []);

  const fetchItemsByCategory = async (categoryId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Items/by-category/${categoryId}`
      );
      const data = await response.json();
      setItems(data);
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const fetchSalesOfferID = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}SalesOffers/all-desc`);
      const data = await response.json();
      const nextID = (data.salesOfferID || 0) + 1;
      setSalesOfferNo(`SO-${nextID}`);
    } catch (error) {
      console.error("Failed to fetch sales offer ID", error);
    }
  };
  useEffect(() => {
    fetchSalesOfferID();
  }, []);

  const fetchSalesOfferDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}SalesOffers/details`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to fetch sales offer details", error);
      return [];
    }
  };
  useEffect(() => {
    const loadDetails = async () => {
      const details = await fetchSalesOfferDetails();
      setSalesOfferDetails(details);
    };

    loadDetails();
  }, []);

  const handleCategoryChange = (selected) => {
    setValue("category", selected?.value || "");
    const filteredItems = dummyData.filter(
      (item) => item.category === selected?.value
    );
    setItems(filteredItems);
    setValue("item", null);
    setSelectedItem(null);
    setValue("stock", "");
    setValue("cost", "");
  };

  const handleItemChange = (selectedOption) => {
    const selectedItem = items.find(
      (item) => item.itemID === selectedOption?.value
    );

    if (selectedItem) {
      setSelectedItemDetails(selectedItem);
      setSelectedItem(selectedItem.itemID);
      setValue("stock", selectedItem.stock);
      setValue("cost", selectedItem.costPerUnit);
      setValue("vat", selectedItem.vatPercent);
    } else {
      setSelectedItemDetails(null);
      setValue("stock", "");
      setValue("cost", "");
      setValue("vat", selectedItem.vatPercent);
    }

    trigger("item");
  };

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerImageFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleProductImagesChange = (e) => {
    const files = Array.from(e.target.files);
    const urls = files.map((file) => URL.createObjectURL(file));
    setProductPreviewUrls(urls);
    setProductImageFiles(files);
  };

  const onSubmit = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    const userId = localStorage.getItem("userId");

    const formData = new FormData();

    formData.append("ItemID", selectedItemDetails.itemID);
    formData.append("QuantityAvailable", data.stock);
    formData.append("SellingPrice", data.sellingPrice);

    const vatCharges = vatApplied
      ? (parseFloat(data.sellingPrice) * 0.15).toFixed(2)
      : 0;
    formData.append("VatCharges", vatCharges);

    formData.append("DiscountPercent", data.discount || 0);

    const sizesArray = data.sizes.split(",").map((s) => s.trim());
    sizesArray.forEach((size, i) => {
      formData.append(`Sizes[${i}]`, size);
    });

    if (bannerImageFile) {
      formData.append("BannerImage", bannerImageFile);
    }

    productImageFiles.forEach((file) => {
      formData.append("ProductImages", file);
    });

    formData.append("ProductDescription", data.description);
    formData.append("SummaryDescription", data.summary);
    formData.append("TermsAndConditions", data.terms);

    formData.append("userid", 8);
    formData.append("CreatedBy", userId);
    formData.append("CreatedOn", new Date().toISOString());
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }
    try {
      const response = await fetch(`${API_BASE_URL}SalesOffers/create`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Something went wrong!");

      const result = await response.json();
      console.log("Submitted successfully", result);

      toast.success("Order added successfully! ");
      const updatedDetails = await fetchSalesOfferDetails();
      setSalesOfferDetails(updatedDetails);
      fetchSalesOfferID();
      reset({
        item: null,
        stock: "",
        cost: "",
        vat: "",
        sellingPrice: "",
        vatApplied: "",
        discount: "",
        sizes: "",
        bannerImage: "",
        productImages: "",
        description: "",
        terms: "",
        summary: "",
      });
      reset();
      setProductPreviewUrls([]);
      setPreviewUrl("");
      setSelectedCategory(null);
      setSelectedItem(null);
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Failed to add order. ");
    }
  };

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Sales Offer No",
      selector: (row) => `SO-${row.salesOfferID}`,
      sortable: true,
      width: "150px",
    },
    {
      name: "Item",
      selector: (row) => row.itemName,
      sortable: true,
      width: "180px",
    },
    {
      name: "UoM",
      selector: (row) => row.unitName,
      sortable: true,
      width: "100px",
    },
    {
      name: "Price / Unit",
      selector: (row) => row.costPerUnit,
      sortable: true,
      width: "130px",
    },
    {
      name: "VAT",
      selector: (row) => `${row.vat}%`,
      sortable: true,
      width: "100px",
    },
    {
      name: "Gross Amount",
      selector: (row) => row.grossAmount,
      sortable: true,
      width: "150px",
    },
    {
      name: "Discount%",
      selector: (row) => `${row.discount}%`,
      sortable: true,
      width: "120px",
    },
    {
      name: "Net Selling Amount",
      selector: (row) => row.netSellingAmount,
      sortable: true,
      width: "170px",
    },
    {
      name: "Quantity Available",
      selector: (row) => row.stock,
      sortable: true,
      width: "170px",
    },
  ];

  const dummyData = [
    {
      id: 1,
      salesOfferNo: "SO-0001",
      itemName: 'Boy Shirt 18"',
      uom: "PCS",
      pricePerUnit: 45,
      vat: 15,
      grossAmount: 2250,
      discount: 10,
      netAmount: 2025,
      quantityAvailable: 50,
    },
    {
      id: 2,
      salesOfferNo: "SO-0002",
      itemName: 'Boy Shirt 17"',
      uom: "PCS",
      pricePerUnit: 42,
      vat: 15,
      grossAmount: 1176,
      discount: 5,
      netAmount: 1117.2,
      quantityAvailable: 28,
    },
    {
      id: 3,
      salesOfferNo: "SO-0003",
      itemName: 'Boy Shirt 16"',
      uom: "PCS",
      pricePerUnit: 40,
      vat: 15,
      grossAmount: 1160,
      discount: 0,
      netAmount: 1160,
      quantityAvailable: 29,
    },
    {
      id: 4,
      salesOfferNo: "SO-0004",
      itemName: "Chrome Book",
      uom: "PCS",
      pricePerUnit: 100,
      vat: 15,
      grossAmount: 4000,
      discount: 20,
      netAmount: 3200,
      quantityAvailable: 40,
    },
  ];
  const offerColumns = [
    {
      name: "Sales Offer No",
      selector: (row) => row.salesOfferNo,
      sortable: true,
      width: "160px",
    },
    {
      name: "Item Category",
      selector: (row) => row.itemCategory,
      sortable: true,
      width: "160px",
    },
    {
      name: "No. of Items",
      selector: (row) => row.noOfItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      width: "120px",
    },
    {
      name: "Orders Received",
      selector: (row) => row.ordersReceived,
      sortable: true,
      width: "150px",
    },
    {
      name: "Order Delivered",
      selector: (row) => row.orderDelivered,
      sortable: true,
      width: "150px",
    },
    {
      name: "Created Date",
      selector: (row) => row.createdDate,
      sortable: true,
      width: "150px",
    },
    {
      name: "End Date",
      selector: (row) => row.endDate,
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
      width: "100px",
    },
  ];

  const offerDummyData = [
    {
      salesOfferNo: "SO-1001",
      itemCategory: "Uniform",
      noOfItems: 3,
      status: "Active",
      ordersReceived: 15,
      orderDelivered: 12,
      createdDate: "2025-07-01",
      endDate: "2025-07-10",
      action: "Published",
    },
    {
      salesOfferNo: "SO-1002",
      itemCategory: "IT Equipment",
      noOfItems: 2,
      status: "Completed",
      ordersReceived: 8,
      orderDelivered: 8,
      createdDate: "2025-06-15",
      endDate: "2025-06-30",
      action: "Approved",
    },
    {
      salesOfferNo: "SO-1003",
      itemCategory: "Stationery",
      noOfItems: 5,
      status: "Upcoming",
      ordersReceived: 0,
      orderDelivered: 0,
      createdDate: "2025-07-05",
      endDate: "2025-07-20",
      action: "Published",
    },
  ];

  return (
    <form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
      <div className="card h-100">
        <div className="card-body row g-3">
          <div className="col-md-4">
            <label className="form-label">
              Sales Offer No <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              value={salesOfferNo}
              readOnly
              {...register("offerNo")}
            />
            {errors.offerNo && <small className="text-danger">Required</small>}
          </div>

          <div className="col-md-4"></div>
          <div className="col-md-4"></div>

          <div className="col-md-4">
            <label className="form-label">
              Item Category <span className="text-danger">*</span>
            </label>
            <Controller
              name="category"
              control={control}
              rules={{ required: "Category is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={categories?.map((cat) => ({
                    label: cat.categoryName,
                    value: cat.categoryID,
                  }))}
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption?.value || null);
                    setSelectedCategory(selectedOption?.value || null);

                    if (selectedOption?.value) {
                      fetchItemsByCategory(selectedOption.value);
                    } else {
                      setItems([]);
                      setSelectedItemDetails(null);
                    }
                  }}
                  value={
                    categories
                      .map((cat) => ({
                        label: cat.categoryName,
                        value: cat.categoryID,
                      }))
                      .find((opt) => opt.value === field.value) || null
                  }
                  isClearable
                  className="react-select-style"
                  classNamePrefix="react-select-style-pref"
                />
              )}
            />
            {errors.category && (
              <small className="text-danger">{errors.category.message}</small>
            )}
          </div>

          <div className="col-md-4">
            <label className="form-label">
              Item <span className="text-danger">*</span>
            </label>
            <Controller
              name="item"
              control={control}
              rules={{ required: "Item is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={items.map((item) => ({
                    label: item.itemName,
                    value: item.itemID,
                  }))}
                  value={field.value}
                  onChange={(selectedOption) => {
                    handleItemChange(selectedOption);
                    field.onChange(selectedOption);
                  }}
                  className="react-select-style"
                  classNamePrefix="react-select-style-pref"
                  isClearable
                />
              )}
            />
            {errors.item && (
              <small className="text-danger">{errors.item.message}</small>
            )}
          </div>

          <div className="col-md-4">
            <label className="form-label">Stock Available</label>
            <input className="form-control" readOnly {...register("stock")} />
          </div>

          <div className="col-md-4">
            <label className="form-label">Cost</label>
            <input className="form-control" readOnly {...register("cost")} />
          </div>

          <div className="col-md-4">
            <label className="form-label">
              Selling Price <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control"
              {...register("sellingPrice", { required: true })}
            />
            {errors.sellingPrice && (
              <small className="text-danger">Required</small>
            )}
          </div>

          <div className="col-md-4">
            <label className="form-label d-flex align-items-center">
              VAT Apply
              <input
                type="checkbox"
                className="form-check-input ms-2"
                {...register("vatApplied")}
                id="vatCheckbox"
              />
            </label>

            {vatApplied && (
              <div>
                <div className="input-group">
                  <span className="input-group-text">15%</span>
                  <input
                    type="text"
                    className="form-control"
                    value={(Number(sellingPrice) * 1.15).toFixed(2)}
                  />
                </div>
              </div>
            )}
          </div>

          <div className="col-md-4">
            <label className="form-label">Discount (%)</label>
            <input
              type="number"
              className="form-control"
              {...register("discount")}
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Sizes (comma separated)</label>
            <input
              className="form-control"
              placeholder="e.g., 18,20,22"
              {...register("sizes")}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">
              Banner Image <span className="text-danger fs-9">*</span>
            </label>
            <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
              <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1">
                {previewUrl ? (
                  <img
                    src={previewUrl}
                    alt="Preview"
                    style={{ maxHeight: "100px" }}
                  />
                ) : (
                  <div>
                    <span className="fas fa-image fs-3 text-light"></span>
                  </div>
                )}
              </div>
              <input
                {...register("bannerImage", {
                  required: !previewUrl ? "This field is required." : false,
                })}
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleBannerChange}
              />
            </div>
            {errors.bannerImage && (
              <small className="text-danger">
                {errors.bannerImage.message}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">
              Product Images <span className="text-danger fs-9">*</span>
            </label>

            <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
              <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1 flex-wrap gap-2">
                {productPreviewUrls.length > 0 ? (
                  productPreviewUrls.map((url, idx) => (
                    <img
                      key={idx}
                      src={url}
                      alt={`Preview ${idx + 1}`}
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  ))
                ) : (
                  <div>
                    <span className="fas fa-image fs-3 text-light"></span>
                  </div>
                )}
              </div>

              <input
                type="file"
                className="form-control"
                multiple
                accept="image/*"
                {...register("productImages", {
                  required:
                    productPreviewUrls.length === 0
                      ? "This field is required."
                      : false,
                })}
                onChange={handleProductImagesChange}
              />
            </div>

            {errors.productImages && (
              <small className="text-danger">
                {errors.productImages.message}
              </small>
            )}
          </div>

          <div className="col-md-12">
            <label className="form-label">Product Description</label>
            <textarea
              className="form-control"
              rows="4"
              {...register("description")}
            />
          </div>

          <div className="col-md-12">
            <label className="form-label">Summary Description</label>
            <textarea
              className="form-control"
              rows="3"
              {...register("summary")}
            />
          </div>

          <div className="col-md-12">
            <label className="form-label">Terms & Conditions</label>
            <textarea
              className="form-control"
              rows="3"
              {...register("terms")}
            />
          </div>

          <div className="col-md-12">
            <button type="submit" className="btn btn-primary">
              Add Item
            </button>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card h-100">
            <div className="card-body">
              <div className="table-container">
                <DataTable
                  columns={columns}
                  data={salesOfferDetails}
                  pagination
                  paginationPerPage={rowsPerPage}
                  paginationRowsPerPageOptions={[10, 20, 30, 40, 50]}
                  dense
                  customStyles={customTableStyles}
                  highlightOnHover={true}
                  onChangePage={setCurrentPage}
                  onChangeRowsPerPage={setRowsPerPage}
                />
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button className="btn btn-primary">Create Order</button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card h-100">
            <div className="card-body">
              <div className="table-container fixed-last-column-table">
                <DataTable
                  columns={offerColumns}
                  data={offerDummyData}
                  pagination
                  paginationPerPage={rowsPerPage}
                  paginationRowsPerPageOptions={[10, 20, 30, 40, 50]}
                  dense
                  customStyles={customTableStyles}
                  highlightOnHover={true}
                  onChangePage={setCurrentPage}
                  onChangeRowsPerPage={setRowsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SalesOfferForm;
